import { SetStateAction, useContext, useEffect, useState } from "react"
import { FiltroEstoque } from "../components/filtroEstoque"
import { Veiculo } from "../shared/types";
import { CardVeiculo } from "../components/cardVeiculo";
import { isMobile, scrollToTop } from "../shared/utils/javascript";
import { useLocation } from "react-router-dom";
import { AuthContext } from "../shared/context/auth";

type BuscaType = {
    categoria: string,
    marca: string,
    modelo: string,
    precoDe: string,
    precoAte: string,
    anoDe: string,
    busca: string,
}

export const Estoque = () => {

    const location = useLocation();
    const { estoque } = useContext(AuthContext)
    const [estoqueFiltrado, setEstoqueFiltrado] = useState<Veiculo[]>([]);
    const [busca, setBusca] = useState<BuscaType>();

    const itensPorPagina = 12;
    const [paginaAtual, setPaginaAtual] = useState(1);
    const indiceInicio = (paginaAtual - 1) * itensPorPagina;
    const indiceFim = indiceInicio + itensPorPagina;
    const itensDaPagina = estoqueFiltrado.slice(indiceInicio, indiceFim);

    const numeroDePaginas = Math.ceil(estoqueFiltrado.length / itensPorPagina);

    const handleClickPagina = (novaPagina: SetStateAction<number>) => {
        setPaginaAtual(novaPagina);
        scrollToTop();
    };
    const handleFilterEstoque = () => {
        setEstoqueFiltrado(estoque)
        if(busca === undefined) {
            setEstoqueFiltrado(estoque)
        } else {
            const filtroEstoque = estoque.filter(item => {
                const categoriaMatch = busca?.categoria === '' || item.categoria === busca?.categoria;
                const marcaMatch = busca?.marca === '' || item.marca === busca?.marca;
                const modeloMatch = busca?.modelo === '' || item.modelo === busca?.modelo;
                const valorDeMatch = busca?.precoDe === '' || item.valor >= Number(busca?.precoDe);
                const valorAteMatch = busca?.precoAte === '' || item.valor <= Number(busca?.precoAte);
                const anoMatch = busca?.anoDe === '' || item.ano === Number(busca?.anoDe);
    
                return categoriaMatch && marcaMatch && modeloMatch && valorDeMatch && valorAteMatch && anoMatch;
              });
              let estoqueFiltradoOrdenado = [...filtroEstoque];
              if (busca?.precoDe !== "0") {
                  // Primeiro, ordena por valor
                  estoqueFiltradoOrdenado.sort((a, b) => a.valor - b.valor);
                  // Em seguida, ordena por ano (maior para menor)
                  estoqueFiltradoOrdenado.sort((a, b) => b.ano - a.ano);
              }
              setEstoqueFiltrado(estoqueFiltradoOrdenado);
        }
    }

    useEffect(() => {
        handleFilterEstoque();
        scrollToTop()
    },[busca, estoque]) 

    useEffect(() => {
        const queryString = window.location.search;       
        const paramsString = new URLSearchParams(queryString).get('params');
    
        if (paramsString) {
            try {
                const paramsObj = JSON.parse(decodeURIComponent(paramsString));
                setBusca(paramsObj)
            } catch (error) {
                //
            }
        }
    }, [location.search]);

    return (
        <div className="px-28 bg-secondary py-16 flex flex-col gap-14 mobile:px-3 mobile:gap-5 min-h-[80vh]">
            {/* Filtro */}
            <div className="flex items-center gap-3">
                {isMobile() ? null : (
                    <FiltroEstoque />
                    )}
            </div>
            {isMobile() ? (
                <FiltroEstoque />
            ) : null}

            {/* Estoque */}
            <div className="grid grid-cols-3 gap-11 mobile:mt-5 mobile:flex mobile:flex-col">
                {itensDaPagina.map((x) => (
                    <CardVeiculo key={x.cod_veiculo} veiculo={x} />
                ))}
            </div>
            
            {/* Paginação */}
            <div className="flex flex-row mt-4 items-center justify-center">
                <i className="ri-arrow-left-s-line mr-2 cursor-pointer text-white" onClick={() => {
                    if(paginaAtual === 1) return
                    handleClickPagina(paginaAtual - 1)
                }}></i>
                {Array.from({ length: numeroDePaginas }, (_, index) => (
                    <button
                    key={index + 1}
                    className={`px-3 text-white py-1 ${paginaAtual - 4 > index ? "hidden" : ""} ${paginaAtual + 2 < index ? "hidden" : ""} ${paginaAtual === index + 1 ? 'border border-white font-semibold' : 'text-white'}`}
                    onClick={() => handleClickPagina(index + 1)}
                    >
                    {index + 1}
                </button>
                ))}
                <i className="ri-arrow-right-s-line ml-2 text-white" onClick={() => {
                    if(paginaAtual === numeroDePaginas) return
                    handleClickPagina(paginaAtual + 1)
                }}></i>
            </div>
        </div>
    )
}